import React, { useState, useContext, useEffect, useRef } from 'react';
import {
  Grid,
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import BlurTable from '../../../assets/img/blurTable.jpg';

import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../../../assets/css/buttons.css';

function SellScreenList({ updateAmountShortcut, isTab, isRefill }) {
  const { t } = useTranslation();

  const {
    ticketSelectedKioskCH,
    updateTicketSelectedKioskCH,
    parentInfo,
    updateOpenSessionTerminal,
    userLogin,
    userInfo,
    userSiblings,
    userChildren,
    session,
    operator,
    hall,
    updateUserLogin,
    currentUser,
    updateCurrentUser,
    updateCurrentUserID,
    updateUserInfo,
    updateIsFullUser,
    updateIsAnonUser,
    updateIsHybridUser,
    updateIsFastUserLogin,
    updateUserChildren,
    updateUserParent,
    updateUserSiblings,
    ticketsCH,
  } = useContext(AppContext);

  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const handleSearchMember = (data) => {
      if (data.records[0].username.slice(0, 4) !== 'anon') {
        return;
      }

      if (!data || !data.records) {
        toast.error(t('error.error'));
        return;
      }
      if (data.records.length > 1) {
        //modalUserFound(data.records);
        return;
      }
      if (data.records.length === 0) {
        //modalUserNotFound();
        return;
      }

      const amountToRefill = data.records[0].balances.wallet;

      //setTicketActive(data.records[0]["7 digit PIN"])

      updateUserLogin(true);
      updateUserInfo(data.records[0]);
      updateCurrentUser(data.records[0]['7 digit PIN']);
      updateCurrentUserID(data.records[0]['id']);

      socket.emit('openSessions', data.records[0]['id']);

      if (data.siblings) {
        updateUserSiblings(data.siblings);
      }

      if (data.children) {
        updateUserChildren(data.children);
      }

      var dataToRegisterObj = [];
      dataToRegisterObj.push(data.records[0]);
      if (
        data.records[0].username.slice(0, 4) === 'anon' ||
        (data.records[0].firstname === '' && data.records[0].mobile === '')
      ) {
        //ANON
        updateIsFullUser(false);
        updateIsHybridUser(false);
        updateIsAnonUser(true);
        if (data.parent) {
          updateUserParent(data.parent);
          var data = {
            auth_value: data.parent.parentID,
            searchByID: true,
            action: 'searchMemberParent',
            session: session,
          };
          socket.emit('searchMemberParent', data);
        }
        if (data.siblings) {
          updateUserSiblings(data.siblings);
        }
      } else if (data.records[0].username.slice(0, 6) === 'hybrid') {
        //Hybrid, don't do shit
        updateIsFullUser(false);
        updateIsHybridUser(true);
        updateIsAnonUser(false);
      } else {
        //Parent, save the children if exist
        if (data.children) {
          updateUserChildren(data.children);
        }
        updateIsFullUser(true);
        updateIsHybridUser(false);
        updateIsAnonUser(false);
      }

      updateIsFastUserLogin(false);

      var dataToRegister = {
        action: 'registerLastUsers',
        operator: operator,
        bingoName: hall,
        sessionID: session,
        user7Pincode: dataToRegisterObj[0]['7 digit PIN'],
        username: dataToRegisterObj[0].username,
        firstname:
          !dataToRegisterObj[0].firstname ||
          dataToRegisterObj[0].firstname === ''
            ? 'Uregistrert'
            : dataToRegisterObj[0].firstname,
        userInfo: dataToRegisterObj[0],
        isFastUserLogin: 0,
      };
      registerLastUsers(dataToRegister);

      if (!isRefill && isRefill !== undefined) {
        setTimeout(() => {
          updateAmountShortcut(amountToRefill);
        }, 90);
      }
    };

    const handleSms = (data) => {
      setSmsGenerated(data);

      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      setSmsGenerated(data);
    };

    const handleSearchMemberParent = (data) => {};

    socket.on('searchMember', handleSearchMember);
    socket.on('searchMemberParent', handleSearchMemberParent);
    socket.on('sms', handleSms);

    return () => {
      socket.off('searchMember', handleSearchMember);
      socket.off('sms', handleSms);
      socket.off('searchMemberParent', handleSearchMemberParent);
    };
  }, [socket]);

  const [smsGenerated, setSmsGenerated] = useState(''); // State to control focus
  const [usernameRegister, setUsernameRegister] = useState('');
  const [phonenumberRegister, setPhonenumberRegister] = useState('');

  const smsGeneratedRef = useRef(smsGenerated);
  useEffect(() => {
    smsGeneratedRef.current = smsGenerated;
  }, [smsGenerated]);

  const usernameRegisterRef = useRef(usernameRegister);
  useEffect(() => {
    usernameRegisterRef.current = usernameRegister;
  }, [usernameRegister]);

  const phonenumberRegisterRef = useRef(phonenumberRegister);
  useEffect(() => {
    phonenumberRegisterRef.current = phonenumberRegister;
  }, [phonenumberRegister]);

  const sessionRef = useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const [dataTickets, setDataTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);

  const registerLastUsers = (data) => {
    if (data.operator === '') {
      return;
    }
    socket.emit('registerLastUsers', data);
  };

  useEffect(() => {
    if (userSiblings.length > 0) {
      setDataTickets(userSiblings);
    } else if (userChildren.length > 0) {
      setDataTickets(userChildren);
    }
  }, [userSiblings, userChildren]);

  useEffect(() => {
    const filterTickets = async () => {
      const result = [];

      for (const ticket of dataTickets) {
        const ticketExist = userExists(ticketsCH, ticket.ticket7Pincode);

        if (!ticketExist) {
          result.push(ticket);
        }
      }

      setFilteredTickets(result);
    };

    filterTickets();
  }, [dataTickets, ticketsCH]);

  const userExists = (array, user7Pincode) => {
    return array.some((user) => user.user7Pincode === user7Pincode);
  };

  const activateTicket = (ticket) => {
    console.log('Activating ticket:', ticket);
    updateTicketSelectedKioskCH(ticket);
  };

  const glassBg = 'rgba(255,255,255,0.06)';
  const glassBorder = '1px solid rgba(255,255,255,0.12)';
  const headBg = 'rgba(0,0,0,0.20)';

  const tableContainerSx = {
    flex: 1,
    minHeight: 0,
    height: '100%',
    maxHeight: '100%',
    overflowY: 'auto',
    borderRadius: '18px',
    border: glassBorder,
    background: glassBg,
    boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.04)',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': { display: 'none' },

    // quita el blanco del Paper
    '&.MuiPaper-root': { background: 'transparent', boxShadow: 'none' },

    '& .MuiTable-root': { background: 'transparent' },
    '& .MuiTableCell-root': {
      color: 'white',
      borderBottom: '1px solid rgba(255,255,255,0.08)',
      padding: '14px 16px',
      fontSize: '18px',
    },
    '& .MuiTableCell-head': {
      position: 'sticky',
      top: 0,
      zIndex: 2,
      background: headBg,
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      color: 'rgba(255,255,255,0.82)',
      fontWeight: 900,
      textTransform: 'uppercase',
      letterSpacing: '0.12em',
      fontSize: '15px',
      borderBottom: '1px solid rgba(255,255,255,0.10)',
    },
  };

  const actionBtnSx = {
    height: '44px',
    fontSize: '15px',
    borderRadius: '999px',
    border: '1px solid rgba(255,255,255,0.16)',
    color: 'white',
    fontWeight: 900,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    background: 'rgba(255,255,255,0.06)',
    '&:hover': { background: 'rgba(255,255,255,0.10)' },
  };

  return (
    <Grid
      item
      xs={12}
      sx={{
        padding: '10px',
        height: '100%',
        minHeight: isTab ? 0 : '555px',
        width: '100%',
        marginTop: isTab ? '0px' : '40px',
        marginLeft: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        minHeight: 0,
      }}
    >
      {!isTab && (
        <h2 style={{ textAlign: 'left', width: '100%', margin: '0 0 10px 0' }}>
          {t('sales.payoutTicket')}
        </h2>
      )}

      <Grid
        container
        flexDirection="row"
        sx={{
          flex: 1,
          minHeight: 0,
          width: '100%',
          marginTop: 0,
          marginLeft: 0,
          display: 'flex',
          justifyContent: 'flex-start',
          alignContent: 'stretch',
          alignItems: 'stretch',
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            border: '2px solid black',
            width: '100%',
            maxWidth: '100% !important',
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            //backgroundColor: '#232a45',
          }}
        >
          <TableContainer component={Paper} sx={tableContainerSx}>
            <Table
              sx={{
                color: 'white',
                background: 'transparent',
              }}
              stickyHeader
              aria-label="simple table"
            >
              <TableHead sx={{ background: 'transparent' }}>
                <TableRow>
                  <TableCell align="center">
                    {t('apneBilleter.ticketID')}
                  </TableCell>
                  <TableCell align="center"> </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredTickets.length > 0 && (
                  <>
                    {filteredTickets.map((ticket, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },

                          backgroundColor:
                            ticketSelectedKioskCH.ticket7Pincode ===
                            ticket.ticket7Pincode
                              ? 'rgba(34,197,94,0.14)'
                              : index % 2 === 0
                                ? 'rgba(255,255,255,0.03)'
                                : 'rgba(255,255,255,0.015)',

                          '&:hover td': {
                            backgroundColor:
                              ticketSelectedKioskCH.ticket7Pincode ===
                              ticket.ticket7Pincode
                                ? 'rgba(34,197,94,0.18)'
                                : 'rgba(255,255,255,0.05)',
                          },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          align="center"
                          sx={{
                            color:
                              ticketSelectedKioskCH.ticket7Pincode ===
                              ticket.ticket7Pincode
                                ? '#18ff18'
                                : 'inherit',
                          }}
                        >
                          {ticket.ticket7Pincode}
                        </TableCell>

                        <TableCell align="center">
                          {ticketSelectedKioskCH.ticket7Pincode !==
                          ticket.ticket7Pincode ? (
                            <Button
                              size="small"
                              variant="outlined"
                              sx={actionBtnSx}
                              onClick={() => {
                                activateTicket(ticket);
                              }}
                            >
                              {!isRefill
                                ? t('sales.payout')
                                : t('sales.refill')}
                            </Button>
                          ) : (
                            <Button
                              size="small"
                              variant="outlined"
                              sx={{
                                ...actionBtnSx,
                                border: '1px solid rgba(34,197,94,0.35)',
                                background: 'rgba(34,197,94,0.10)',
                              }}
                              onClick={() => {
                                activateTicket(ticket);
                              }}
                            >
                              {t('sales.selected')}
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SellScreenList;
